import { addEventToDataLayerGT3 } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS } from "@website/tracking/tracking.types";
import { SnackbarSeverity } from "@website/ui/snackbar-v2";
import { datalayerAppName } from "@website/widget/telesales/constants";
import { TelesalesAppName } from "@website/widget/telesales/types";
import toNumber from "lodash-es/toNumber";
import { useCallback, useState } from "react";

export const useTelesales = (storageKey: string, app: TelesalesAppName) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isSubmitBefore, setIsSubmitBefore] = useState<boolean>(false);
  const [snackbar, setSnackbar] = useState<{
    title: string;
    severity?: SnackbarSeverity;
  }>({
    title: ""
  });

  const handleOpenModal = useCallback(() => {
    setIsOpenModal(true);
    addEventToDataLayerGT3(DATA_LAYER_EVENTS.TELESALES_BUTTON_CLICK, {
      item: [
        {
          item_brand: datalayerAppName[app]
        }
      ]
    });
    const timestamp = toNumber(localStorage.getItem(storageKey));
    setIsSubmitBefore(
      Boolean(timestamp) && Date.now() - timestamp <= 10_800_000
    );
  }, [app, storageKey]);

  const onSubmitSuccess = () => {
    setSnackbar({
      title: "درخواست شما با موفقیت ثبت شد.",
      severity: "success"
    });
  };
  const onCloseSnackbar = useCallback(() => {
    setSnackbar({ title: "" });
  }, []);

  return {
    isOpenModal,
    setIsOpenModal,
    handleOpenModal,
    isSubmitBefore,
    snackbar,
    onSubmitSuccess,
    onCloseSnackbar
  };
};
